module.exports = __webpack_public_path__ + "static/assets/f1df5d37000de851996bc729d1eba575.svg";